<template>
  <div v-cloak>
    <div class="q_rank">
      <div class="q_vertical_left q_pad_tb10px q_bor_top">
        <div class="q_inlineblock">
          <van-image class="q_join_img" fit="cover" :src="convertImg(userActivityTimeUser.avatar)"/>
        </div>
        <div class="q_mar_l15px q_inlineblock q_con">
          <div class="q_text_m q_bold q_moit1 q_justify" v-text="userActivityTimeUser.name">张三</div>
        </div>
        <div class="q_inlineblock q_right q_time">
          <span class="q_text_s q_color_default q_bold" v-text="userActivityTimeUser.timeLong + '小时'">50小时</span>
        </div>
      </div>
      <div class="q_vertical_left q_pad_tb10px q_bor_top" v-for="item in userActivityTimeUserDetailsList"
           v-if="userActivityTimeUserDetailsList.length>0">
        <div class="q_inlineblock q_name">
          <div class="q_text_m q_bold q_moit1 q_justify">{{ item.activityName }}</div>
          <div class="q_text_s q_color_gray q_mar_t5px">{{ item.lastSignOutTime }}</div>
        </div>
        <div class="q_inlineblock q_right q_time">
          <span class="q_text_s q_color_default q_bold">{{ item.timeLong + '小时' }}</span>
        </div>
      </div>
      <!--空数据-->
      <div class="q_center" style="margin-top: 26vh;" v-if="userActivityTimeUserDetailsList.length==0">
        <img src="@/assets/image/none.png" style="width: 26vw;"/>
        <p class="q_color_gray q_text_s q_mar_t20px">暂无信息</p>
      </div>
    </div>
  </div>
</template>

<script>
import {
  userActivityTimeUserDetailsMonthById,
  userActivityTimeUserDetailsQuarterById,
  userActivityTimeUserDetailsYearById
} from "@/api/userActivity";
import {wxCloseShare} from "@/utils/jiutang";

export default {
  name: 'Join',
  props: {
    msg: String
  },
  data() {
    return {
      loading: true,
      userActivityTimeUser: {
        name: '加载中...',
        timeLong: 0
      },
      userActivityTimeUserDetailsList: [],
      type: undefined,
      userId: undefined
    }
  },
  created() {
    wxCloseShare()
    this.type = this.$route.query.type;
    this.userId = this.$route.query.userId;
    this.init()
  },
  methods: {
    /**
     * 初始化
     */
    init() {
      this.loading = true
      this.$modal.loading()
      if (this.type == 'month') {
        userActivityTimeUserDetailsMonthById(this.userId).then(res => {
          this.userActivityTimeUser = res.data.userActivityTimeUser
          this.userActivityTimeUserDetailsList = res.data.userActivityTimeUserDetailsList
        }).finally(() => {
          this.loading = false
          this.$modal.closeLoading()
        })
      }

      if (this.type == 'quarter') {
        userActivityTimeUserDetailsQuarterById(this.userId).then(res => {
          this.userActivityTimeUser = res.data.userActivityTimeUser
          this.userActivityTimeUserDetailsList = res.data.userActivityTimeUserDetailsList
        }).finally(() => {
          this.loading = false
          this.$modal.closeLoading()
        })
      }

      if (this.type == 'year') {
        userActivityTimeUserDetailsYearById(this.userId).then(res => {
          this.userActivityTimeUser = res.data.userActivityTimeUser
          this.userActivityTimeUserDetailsList = res.data.userActivityTimeUserDetailsList
        }).finally(() => {
          this.loading = false
          this.$modal.closeLoading()
        })
      }
    }
  },
}
</script>
<style scoped="scoped">
.q_join_img {
  width: 40px;
  height: 40px;
}

.q_join_img >>> .van-image__img {
  border-radius: 30px;
}

.q_con {
  width: 190px;
}

.q_name {
  width: 245px;
}

.q_time {
  width: 90px;
}

.q_rank {
  padding: 0 15px;
}
</style>
